var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1693 0C20.3992 0 22.2069 1.79086 22.2069 4V18C22.2069 20.2091 20.3992 22 18.1693 22H4.03762C1.8077 22 0 20.2091 0 18V4C0 1.79086 1.8077 0 4.03762 0H18.1693ZM18.1724 2H4.04071C2.92576 2 2.0219 2.89543 2.0219 4V14.4655C2.0219 14.5759 2.11229 14.6655 2.22379 14.6655C2.2553 14.6655 2.28638 14.6582 2.31453 14.6441L8.38479 11.618C10.097 10.7641 12.1163 10.7636 13.8289 11.6168L19.8986 14.6403C19.9982 14.6899 20.1196 14.6501 20.1697 14.5514C20.1838 14.5236 20.1912 14.4928 20.1912 14.4616V4C20.1912 2.89543 19.2873 2 18.1724 2ZM6.55948 4C7.95318 4 9.08299 5.11929 9.08299 6.5C9.08299 7.88071 7.95318 9 6.55948 9C5.16579 9 4.03597 7.88071 4.03597 6.5C4.03597 5.11929 5.16579 4 6.55948 4Z",
    fill: "#A5ABB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.fa7bc10bcb336aac30b5b88aacb9da98.svg";
export { ForwardRef as ReactComponent };